<script lang="ts">
    import handWaving from "$lib/assets/HandWaving.svg";
    import Header from "$lib/components/Header.svelte";
</script>

<div class="variant-filled-surface p-8 space-y-0 rounded-lg w-[400px]">
    <Header src={handWaving} text="Book a Call" />
    <!-- Calendly inline widget begin -->
    <div
        class="calendly-inline-widget h-[600px] min-w-[320px]"
        data-url="https://calendly.com/grantscout/grantscout-intro-meeting-30-min?hide_event_type_details=1&hide_gdpr_banner=1"
    ></div>
    <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
    <!-- Calendly inline widget end -->
</div>
